// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"119":"f2acbcb6","137":"54ea2cf5","373":"58831197","427":"130d68ff","453":"af907c37","648":"39937438","747":"3b912df2","885":"47987909","895":"19564197"}[chunkId] + ".chunk.js";
};